import { ref, computed } from "vue";
import { SUPPORT_STATUS, VALIDATION_RULES } from "./constants";
import axios from "axios";
import { t } from "@/controllerLK/GlobusLocalization";

export function useSupportForm() {
    const submitStatus = ref(SUPPORT_STATUS.IDLE);

    const supportForm = ref({
        title: t("support_widget.title"),
        name: "",
        email: "",
        question: "",
        file: null,
    });

    // Валидация полей
    const isNameValid = computed(() =>
        supportForm.value.name.trim().length >= VALIDATION_RULES.NAME_MIN_LENGTH
    );

    const isEmailValid = computed(() =>
        VALIDATION_RULES.EMAIL_PATTERN.test(supportForm.value.email.trim())
    );

    const isQuestionValid = computed(() =>
        supportForm.value.question.trim().length >= VALIDATION_RULES.QUESTION_MIN_LENGTH
    );

    const isFormValid = computed(() =>
        isNameValid.value && isEmailValid.value && isQuestionValid.value
    );

    // Отправка формы
    const submitForm = async () => {
        if (!isFormValid.value) return;

        submitStatus.value = SUPPORT_STATUS.LOADING;

        const formData = {
            title: supportForm.value.title.trim(),
            user_name: supportForm.value.name.trim(),
            user_email: supportForm.value.email.trim(),
            body: supportForm.value.question.trim(),
        };

        // API пока-что не принимает файлы
        // if (supportForm.value.file?.file) {
        //     formData.file = supportForm.value.file.file;
        // }

        try {
            const response = await axios.post("/mailer/api/messages", formData);

            if (response.status === 200 || response.status === 201) {
                submitStatus.value = SUPPORT_STATUS.SUCCESS;
                resetForm();
            } else {
                console.error("Ошибка отправки формы.");
                submitStatus.value = SUPPORT_STATUS.ERROR;
            }
        } catch (error) {
            console.error("Ошибка отправки формы:", error);
            submitStatus.value = SUPPORT_STATUS.ERROR;
        }
    };

    const resetForm = () => {
        supportForm.value.question = "";
        supportForm.value.file = null;
    };

    const resetStatus = () => {
        submitStatus.value = SUPPORT_STATUS.IDLE;
    };

    return {
        supportForm,
        submitStatus,
        isFormValid,
        isNameValid,
        isEmailValid,
        isQuestionValid,
        submitForm,
        resetForm,
        resetStatus
    };
}